const formatRouteForAAB = ({ appointmentMenuItems , appointmentRoute , route , searchParams  })=>{
    return appointmentMenuItems.map((item)=>{
        var ref, ref1;
        if (item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : (ref1 = ref.href) === null || ref1 === void 0 ? void 0 : ref1.startsWith(appointmentRoute)) {
            item.link.href = `${appointmentRoute}${route ? `/${route}` : ''}?${searchParams}`;
        }
        return item;
    });
};

export { formatRouteForAAB };
//# sourceMappingURL=format-route-for-aab.js.map
